window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }
    if (typeof Swiper !== 'undefined') {
    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: 15,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        768: {
          slidesPerView: tabletShow,
        },
        1024: {
          slidesPerView: largeDesktopShow,
        },
        1280: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });
  }
  return sliderProduct;
}
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerCategoryMenu = new theme.Sections();

  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerCartModule.register("header", theme.CartDrawerActions);
  headerStickyModule.register("header", theme.headerSticky);
  headerCategoryMenu.register("header", theme.categoryMenu);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("counter_up", theme.counterup);
  sections.register('faq-collapse', theme.accordion);
  sections.register('instagram', theme.instagramFeed);
  sections.register('welcome-video', theme.video);
});
const MESSAGE = '⚠️ Content protection is active. This action is restricted.';

class ContentProtection {
  constructor(message) {
    this.message = message;
    this.init();
  }

  init() {
    // Prevent right-click context menu
    this.#preventRightClick();
    
    // Prevent text selection
    this.#preventTextSelection();
    
    // Prevent image drag
    this.#preventImageDrag();
    
    // Attempt to prevent developer tools (limited effectiveness)
    this.#preventDevTools();
    
    // Prevent common keyboard shortcuts
    this.#preventKeyboardShortcuts();
  }

  #preventRightClick() {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      console.log(this.message);
      return false;
    });
  }

  #preventTextSelection() {
    // Prevent text selection via mouse
    document.addEventListener('selectstart', (e) => {
      e.preventDefault();
      console.log(this.message);
      return false;
    });

    // Prevent text selection via keyboard (Ctrl+A, etc.)
    document.addEventListener('keydown', (e) => {
      // Ctrl+A (Select All)
      if (e.ctrlKey && e.key === 'a') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
    });
  }

  #preventImageDrag() {
    // Prevent dragging images
    document.addEventListener('dragstart', (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
    }, false);

    // Also prevent via mousedown on images
    document.addEventListener('mousedown', (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
    }, false);

    // Add draggable="false" to all existing images
    document.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', (e) => {
        e.preventDefault();
        console.log(this.message);
        return false;
      });
    });

    // Watch for dynamically added images
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.tagName === 'IMG') {
              node.setAttribute('draggable', 'false');
              node.addEventListener('dragstart', (e) => {
                e.preventDefault();
                console.log(this.message);
                return false;
              });
            }
            // Also check for images within added nodes
            node.querySelectorAll?.('img').forEach((img) => {
              img.setAttribute('draggable', 'false');
              img.addEventListener('dragstart', (e) => {
                e.preventDefault();
                console.log(this.message);
                return false;
              });
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  #preventDevTools() {
    // Prevent F12
    document.addEventListener('keydown', (e) => {
      if (e.key === 'F12') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+Shift+I (Chrome DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+Shift+J (Chrome Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+Shift+C (Chrome Inspect Element)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
    });

    // Detect if DevTools is opened (limited effectiveness)
    let devtools = false;
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: () => {
        devtools = true;
        console.log(this.message);
      }
    });

    setInterval(() => {
      devtools = false;
     /* console.log(element);*/
      if (devtools) {
        console.log(this.message);
      }
    }, 1000);
  }

  #preventKeyboardShortcuts() {
    document.addEventListener('keydown', (e) => {
      // Prevent Ctrl+S (Save Page)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+P (Print)
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
      
      // Prevent Ctrl+Shift+P (Command Palette in some browsers)
      if (e.ctrlKey && e.shiftKey && e.key === 'P') {
        e.preventDefault();
        console.log(this.message);
        return false;
      }
    });
  }
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ContentProtection(MESSAGE);
  });
} else {
  new ContentProtection(MESSAGE);
}